import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { MapPinOff, AlertTriangle, FileSpreadsheet, EyeOff } from "lucide-react";
import { ProblemIllustration } from "./ProblemIllustration";

const problems = [
  { key: "areas", icon: MapPinOff },
  { key: "addresses", icon: AlertTriangle },
  { key: "manual", icon: FileSpreadsheet },
  { key: "overview", icon: EyeOff },
];

export function ProblemsSection() {
  const { t } = useTranslation();

  return (
    <section className="py-12 lg:py-32 bg-secondary/30 min-h-[400px]">
      <div className="container mx-auto px-4 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-2xl mx-auto mb-10 lg:mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-medium font-heading text-primary tracking-tight">
            {t("problems.title")}
          </h2>
          <p className="mt-4 text-lg text-muted-foreground font-body">
            {t("problems.subtitle")}
          </p>
        </motion.div>

        <div className="flex flex-col lg:flex-row gap-8 lg:gap-20 items-center max-w-6xl mx-auto">
          {/* Illustration - hidden on mobile */}
          <motion.div
            className="hidden lg:block flex-1 w-full max-w-md lg:max-w-none"
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.1 }}
          >
            <div className="bg-card rounded-2xl p-6 lg:p-8 border border-border shadow-sm">
              <ProblemIllustration />
            </div>
          </motion.div>

          {/* Problem list */}
          <div className="flex-1 space-y-6">
            {problems.map((problem, index) => (
              <motion.div
                key={problem.key}
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.2 + index * 0.12 }}
                className="flex gap-4"
              >
                <div className="w-12 h-12 rounded-xl bg-coral/10 flex items-center justify-center flex-shrink-0">
                  <problem.icon className="h-5 w-5 text-coral" />
                </div>
                <div>
                  <h3 className="text-lg font-bold font-subheading text-foreground">
                    {t(`problems.items.${problem.key}.title`)}
                  </h3>
                  <p className="text-sm text-muted-foreground font-body leading-relaxed mt-1">
                    {t(`problems.items.${problem.key}.description`)}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
